import { useQuery } from '@apollo/client';
import { ALL_RESPONSE_PRESET_DATA_SETS } from 'graphql/queries';
import { Card, CardHeader, CardBody, Row, Col, Form, FormGroup, Button } from 'reactstrap';
import PresetDataSetSelect from './PresetDataSetSelect';
import { useLocation } from 'react-router';
import { useMemo } from 'react';
import qs from 'qs';
import { cleanQueryString } from 'helpers/global';

const PresetDataSetFilter = ({ surveyId, onSubmit, onReset }) => {
  const { loading: isLoadingDatas, data } = useQuery(ALL_RESPONSE_PRESET_DATA_SETS, {
    variables: {
      surveyId
    },
    notifyOnNetworkStatusChange: true
  });

  const location = useLocation();

  const queryParsed = useMemo(() => {
    const qsParsed = qs.parse(cleanQueryString(location.search));
    return qsParsed['preset_data_set_id'];
  }, [location]);

  return (
    <Card>
      <CardHeader>
        <h3 className="mb-0 text-brand">Filter by Preset Data</h3>
      </CardHeader>
      <CardBody>
        <Form>
          {isLoadingDatas ? (
            <p>Loading...</p>
          ) : (
            <Row>
              <Col xs={12} sm={10}>
                <Row className="input-daterange datepicker align-items-center">
                  {data?.allResponsePresetDataSets?.map((dt) => (
                    <Col xs={12} sm={6} key={dt.id}>
                      <label className=" form-control-label">{dt.name}</label>
                      <FormGroup>
                        <PresetDataSetSelect
                          value={queryParsed ? queryParsed[dt.id] || [] : []}
                          options={dt.presetDataSetDatas}
                          onSelect={(data) => onSubmit(dt.id, data)}
                        />
                      </FormGroup>
                    </Col>
                  ))}
                </Row>
              </Col>
              <Col xs={12} sm={2}>
                <label className="form-control-label">&nbsp;</label>
                <Button
                  color="secondary"
                  className="w-100 rounded-pill"
                  type="button"
                  onClick={() => {
                    onReset();
                  }}>
                  Reset
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </CardBody>
    </Card>
  );
};

export default PresetDataSetFilter;
